<div class="wrapper">
    <div class="left">
        <div class="shine top"></div>
        <div class="shine bottom"></div>
    </div>
    <div class="shine mweb-right"></div>
    <div class="desktop-right">
        <div class="shine"></div>
        <div class="shine"></div>
        <div class="shine"></div>
        <div class="shine"></div>
        <div class="shine"></div>
    </div>
</div>
